import axios from 'axios'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// O handler do backend devolve [{ msgUsuario, msgDesenvolvedor }] em erros de regra de
// negocio (ex.: campo obrigatorio). catchError() ignora esse corpo; aqui surfaceamos a
// mensagem do usuario quando existir, caindo no catchError generico caso contrario.
const erroEnvio = (error: unknown): { message: string } => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data
    const msg = Array.isArray(data) ? data[0]?.msgUsuario : undefined
    if (msg) {
      return { message: msg }
    }
  }
  return catchError(error)
}

export const getPedido = async (
  dataInicio: string,
  numeroDias: number,
  id: number
): Promise<GetPedido | { message: string }> => {
  try {
    const result = await apiService.get(`app/predicao/${id}/pedido`, {
      params: {
        dataInicio,
        numeroDias,
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const criaPedido = async (
  id: number,
  predicaoPedidoRequestDTO: {}
): Promise<PedidoEnvioResultado | { message: string }> => {
  try {
    const result = await apiService.post(`app/predicao/${id}/pedido`, {
      ...predicaoPedidoRequestDTO,
    })
    if (result.status === 200 || result.status === 201) {
      return result.data as PedidoEnvioResultado
    }
  } catch (error) {
    return erroEnvio(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Numa resposta `responseType: 'blob'` o CORPO DO ERRO tambem chega como Blob, entao o
// erroEnvio acima nao acha o msgUsuario (o data e um Blob, nao um array) e engoliria
// justamente a orientacao que importa — por exemplo, "revise o template de PDF em
// Configuracoes", quando o template personalizado do tenant esta malformado.
const erroEnvioEmBlob = async (error: unknown): Promise<string> => {
  const generico = erroEnvio(error).message
  const corpo = axios.isAxiosError(error) ? error.response?.data : undefined
  if (!(corpo instanceof Blob)) {
    return generico
  }
  try {
    const texto = await corpo.text()
    const json = JSON.parse(texto)
    const erro = Array.isArray(json) ? json[0] : json
    return erro?.msgUsuario || generico
  } catch {
    return generico
  }
}

// Gera o PDF do pedido montado na tela (POST app/predicao/{id}/pedido/pdf, application/pdf).
// E POST porque o corpo leva a lista COMO ESTA NA TELA — quantidade editada, linha excluida,
// produto adicionado a mao —, que um GET recalculado no servidor nao reproduziria.
// Vem como blob via axios: `window.open` perderia os headers Authorization/X-TENANT-ID e o
// download voltaria 401.
export const gerarPedidoPdf = async (
  id: number,
  predicaoPedidoPdfRequestDTO: {}
): Promise<Blob | { message: string }> => {
  try {
    const result = await apiService.post(
      `app/predicao/${id}/pedido/pdf`,
      { ...predicaoPedidoPdfRequestDTO },
      { responseType: 'blob' }
    )
    if (result.status === 200) {
      return result.data as Blob
    }
  } catch (error) {
    return { message: await erroEnvioEmBlob(error) }
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const criaPedidoEmMassa =
  async (predicaoPedidoMassaRequestDTO: {}): Promise<
    PedidoMassaResultado | { message: string }
  > => {
    try {
      const result = await apiService.post(`app/predicao/pedido`, {
        ...predicaoPedidoMassaRequestDTO,
      })
      if (result.status === 200 || result.status === 201) {
        return result.data as PedidoMassaResultado
      }
    } catch (error) {
      return erroEnvio(error)
    }
    return {
      message: 'Algo de errado aconteceu!',
    }
  }
